import { Component, OnInit, Input} from '@angular/core';
import { VehicleSummary, VehicleSummaryHeaders } from '../../models/report-viewers';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss']
})
export class ReportSummaryComponent implements OnInit {

  @Input() summary! : VehicleSummary;

  constructor() { }

  ngOnInit(): void {
  }

  getLabel(key: string): string {
    const labels = VehicleSummaryHeaders;
    return labels[key] || key;
  }


  public resumenTotalesEntries(): [string, string][] {
    return Object.entries(this.summary)
      .filter(([_, v]) => v !== undefined && v !== null && v !== '');
  } 
}
